export default __webpack_public_path__ + "static/hotStone-611b7902ff6f04456f0907dbd19c51b2.jpg";